<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <app-list-header [title]="'Attributes List'" [$parent]="getSelf()">
      </app-list-header>
    </div>

    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col mb-2">
                  <button class="btn btn-outline-primary radius-30" data-bs-toggle="modal" data-bs-target="#editModal"
                    (click)="getAttribute(0)" (click)="resetForm()" title="Add">
                    <i class="fa-solid fa-plus"></i> Add
                  </button>

                  <button class="btn btn-outline-primary radius-30 ms-2" (click)="goto()" title="API List">
                    <i class="bx bx-cloud" style="font-size: 25px;"></i> API
                  </button>

                  <button class="btn btn-outline-primary radius-30 ms-2" (click)="gotoData()" title="Data Form">
                    <i class="bx bx-edit" [ngClass]="'bx bx-edit'"></i> Form
                  </button>
                </div>
              </div>
              <!-- table form -->
              <div class="table-responsive mb-3">
                <table id="dataTableId1" class="table">
                  <thead class="table-light">
                    <tr>
                      <th>S.No.</th>
                      <th>Label</th>
                      <th>Code</th>
                      <th>Type</th>
                      <th>Size/Min/Max</th>
                      <th>description</th>
                      <th>Info</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let e of filterAttributesByLabelType();
                        let i = index
                      ">
                      <td>{{ pageIndex(i) }}</td>
                      <td>{{ e["label"] }}</td>
                      <td>
                        {{ e["code"] }}
                      </td>
                      <td>
                        {{ e["type"] }}
                      </td>
                      <td>{{ e["size"] }}/ {{ e["min"] }}/ {{ e["max"] }}</td>
                      <td>
                        {{ e["description"] }}
                      </td>

                      <td>
                        <app-info-button [ele]="e"></app-info-button>


                      </td>

                      <td>
                        <div class="d-flex order-actions">
                          <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal"
                            (click)="getAttribute(e['id'])"><i class="fa fa-edit"></i></a>
                          <a title="Delete" title="Delete" class="ms-1" (click)="this.deleteAttribute(e['id'])"><i
                              class="fa fa-trash"></i></a>

                          <a title="MoveUp" title="MoveUp" class="ms-1" (click)="this.moveIndex(e['id'],-1)"><i
                              class="bx bxs-up-arrow-circle"></i></a>


                          <a title="MoveDown" title="MoveDown" class="ms-1" (click)="this.moveIndex(e['id'],1)"><i
                              class="bx bxs-down-arrow-circle"></i></a>


                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <app-list-header [$parent]="getSelf()"></app-list-header>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form End -->

<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Attributes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
        <button *ngFor="let e of this.atribForm['inputerror'] | keyvalue ; let i = index" type="button"
          class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <p *ngIf="this.atribForm['error']==true" class="btn btn-danger">{{this.atribForm['message']}}</p>
          <div class="row mb-3">
            <label for="label" class="col-sm-3 col-form-label"> Label: </label>
            <div class="col-sm-9">
              <input required [(ngModel)]="this.atribForm['data']['label']" type="text"
                class="form-control form-control-sm" id="label" name="label" pattern="[a-zA-Z][a-zA-Z ]+"
                placeholder="Enter Label" />
            </div>
          </div>
          <div class="row mb-3">
            <label for="type" class="col-sm-3 col-form-label"> Type:</label>
            <div class="col-sm-9">
              <select [(ngModel)]="this.atribForm['data']['type']" id="type" name="type" required
                class="form-select form-select-sm form-select-sm">
                <option *ngFor="let type of types" [value]="type.value">{{ type.label }}</option>
              </select>
            </div>
          </div>
          <div *ngIf="this.atribForm['data']['type'] ==='expression'" class="row mb-2">
            <div class="row mb-3">
              <label for="expression" class="col-sm-3 col-form-label"> Expression:</label>
              <div class="col-sm-9">
                <input id="expression" [(ngModel)]="this.atribForm['data']['expression']" name="expression"
                  placeholder="Exp-  ( :maths + :chemistry+ :physics)/3" required type="text"
                  class="form-control form-control-sm">
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <label for="description" class="col-sm-3 col-form-label">Description
            </label>
            <div class="col-sm-9">
              <textarea required [(ngModel)]="atribForm['data']['description']" type="text"
                class="form-control form-control-sm" id="description" name="description"
                placeholder="Enter Description"></textarea>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col">
              <label for="size" class="col-sm-1 col-form-label col-form-label-sm">Size:</label>
              <input [(ngModel)]="this.atribForm['data']['size']" id="size" name="size" type="number" value="0"
                class="form-control form-control-sm" placeholder="Size" aria-label="Size" />
            </div>
            <div class="col">
              <label for="min" class="col-sm-1 col-form-label col-form-label-sm">Min:</label>
              <input id="min" [(ngModel)]="this.atribForm['data']['min']" name="min" type="number" value="0"
                class="form-control form-control-sm" placeholder="min" aria-label="min" />
            </div>
            <div class="col">
              <label for="max" class="col-sm-1 col-form-label col-form-label-sm">Max:</label>
              <input [(ngModel)]="this.atribForm['data']['max']" id="max" name="max" type="number" value="0"
                class="form-control form-control-sm" placeholder="min" aria-label="max" />
            </div>
          </div>
          <hr />
          <div class="row mb-3">
            <div class="col">
              <div class="form-check">
                <input [(ngModel)]="this.atribForm['data']['required']" class="form-check-input" type="checkbox"
                  id="required" name="required" (change)="
                    this.toggleVal(
                      atribForm['data']['required'],
                      atribForm['data'],
                      'required'
                    )
                  " />
                <label class="form-check-label" for="required">is required?</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input [(ngModel)]="this.atribForm['data']['index']" class="form-check-input" type="checkbox" id="index"
                  name="index" (change)="
                    this.toggleVal(
                      atribForm['data']['index'],
                      atribForm['data'],
                      'index'
                    )
                  " />
                <label class="form-check-label" for="index">Create index</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input [(ngModel)]="atribForm['data']['unique']" class="form-check-input" type="checkbox" id="unique"
                  name="unique" (change)="
                    this.toggleVal(
                      atribForm['data']['unique'],
                      atribForm['data'],
                      'unique'
                    )
                  " />
                <label class="form-check-label" for="unique">unique</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input [(ngModel)]="atribForm['data']['system']" class="form-check-input" type="checkbox" id="system"
                  name="system" (change)="
                    this.toggleVal(
                      atribForm['data']['system'],
                      atribForm['data'],
                      'system'
                    )
                  " />
                <label class="form-check-label" for="system">system</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row mb-3" *ngIf="this.atribForm['data']['type'] === 'list'">
            <div class="input-group mb-2">
              <button for="values" class="btn btn-outline-secondary btn-sm">
                Values
              </button>
              <input [(ngModel)]="tempAttributeValue" #attrValue id="values" name="values" type="text"
                class="form-control form-control-sm" placeholder="Enter a value" />
              <button (click)="addAttributeValue()" class="btn btn-outline-secondary btn-sm">
                <i class="fa fa-plus"></i>Add
              </button>
            </div>
            <div class="mb-2">
              <button *ngFor="let e of this.atribForm['data']['values']" (click)="removeAttribueValue(e)" type="button"
                class="btn btn-outline-secondary btn-sm ms-1">
                {{ e }} <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
          <!-- Type Map -->

          <div class="row" *ngIf="this.atribForm['data']['type'] === 'map'">
            <div class="input-group mb-2">
              <input [(ngModel)]="tempKey" id="key" name="key" type="text" class="form-control form-control-sm"
                placeholder="Enter a key" />
              <input [(ngModel)]="tempMapValue" id="tempMapValue" name="tempMapValue" type="text"
                class="form-control form-control-sm" placeholder="Enter a value" />
              <button (click)="addAttributeMapValue()" class="btn btn-outline-secondary btn-sm">
                <i class="fa fa-plus"></i> Add
              </button>
            </div>
            <div class="mb-2">
              <button *ngFor="let item of this.atribForm['data']['values']" (click)="removeAttribueMapValue(item.key)"
                type="button" class="btn btn-outline-secondary btn-sm ms-1">
                {{ item.key }}: {{ item.value }} <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
          <hr />
          <div class="row mb-3">
            <div class="col">
              <div class="form-check">
                <input [(ngModel)]="atribForm['data']['refKey']" class="form-check-input" type="checkbox" id="refKey"
                  name="refKey" (change)="
                    this.toggleVal(
                      atribForm['data']['refKey'],
                      atribForm['data'],
                      'refKey'
                    )
                  " />
                <label class="form-check-label" for="refKey">Reference Key</label>
              </div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="atribForm['data']['refKey'] == 1">
            <div class="col">
              <label for="primaryUsecase" class="col-sm-1 col-form-label col-form-label-sm">Primary Usecase</label>
              <select [(ngModel)]="atribForm['data']['primaryUsecase']" class="form-select form-select-sm"
                id="primaryUsecase" name="primaryUsecase">
                <option *ngFor="let e of form.list" value="{{ e['collectionName'] }}">
                  {{ e["name"] }}
                </option>
              </select>
            </div>
            <div class="col">
              <label for="depAttribute" class="col-sm-1 col-form-label col-form-label-sm">Dependent Attribute
              </label>
              <select [(ngModel)]="atribForm['data']['depAttribute']" class="form-select form-select-sm"
                id="depAttribute" name="depAttribute">
                <option *ngFor="let e of filterAttributes()" value="{{ e['code'] }}">
                  {{ e["label"] }}
                </option>
              </select>
            </div>
          </div>
        </form>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary btn-sm ml-2" (click)="saveAttribute()"
            [disabled]="!uiForm.valid" title="Save">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal" title="Close">
            <i class="fa fa-window-close"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>